import { API_SETTINGS } from 'constants/api-v2'
import type QueryClient from 'services/query'
import type { Settings } from 'shared/types'

export const loadSettings = (client: QueryClient) => async (): Promise<Settings | undefined> => {
  let settings
  try {
    // Overwrite Headers (we do not send 'authentication' here) to avoid a 401 error in the top route,
    // which somehow blocks the redirection to 'login' page
    const options = null
    const headers = {}
    settings = await client.request(API_SETTINGS, options, headers)
  } catch (e: any) {
    if (e.response) throw e.response
  }

  return settings
}
